<template>
  <div class="w-full">
    <div class="flex justify-end mb-4">
      <div
        class="
          w-10
          h-10
          border border-white-005
          cursor-pointer
          rounded-lg
          flex
          items-center
          justify-center
        "
        @click="() => (state.viewStateList = !state.viewStateList)"
      >
        <span class="icon iconfont">{{
          state.viewStateList ? '&#xe61e;' : '&#xe62c;'
        }}</span>
      </div>
    </div>
    <div class="overflow-x-auto">
      <div
        v-if="state.viewStateList"
        class="
          flex
          items-center
          py-4
          justify-between
          border-b border-white-010
          pr-3.5
        "
        style="min-width: 894px"
      >
        <div class="px-4 text-base text-white-080" style="width: 240px">
          Name
        </div>
        <div class="px-4 text-base text-white-080" style="width: 123px">
          DAO
        </div>
        <div class="px-4 text-base text-white-080" style="width: 144px">
          Title
        </div>
        <div class="px-4 text-base text-white-080" style="width: 263px">
          Description
        </div>
        <div
          class="whitespace-nowrap px-4 text-base text-white-080"
          style="width: 124px"
        >
          Social Media
        </div>
      </div>
      <div
        class="data-container w-full"
        :class="{
          'gap-x-2 md:gap-x-6 gap-y-2 md:gap-y-4 grid grid-cols-2 md:grid-cols-3':
            state.viewStateList === false,
        }"
        :style="`min-width: ${state.viewStateList ? '894px' : 'auto'}`"
        ref="container"
        @scroll="checkScroll"
      >
        <div
          :class="{ 'bg-white-003': i % 2 === 0 }"
          class="hover:bg-white-010 rounded-2xl w-full cursor-pointer relative"
          v-for="(item, i) in displayedItemsArray"
          :style="`height: ${
            state.viewStateList ? 'auto' : isDesktop ? '282px' : '208px'
          }`"
          :key="i"
        >
          <div v-if="state.viewStateList === false" class="h-full">
            <div class="rounded-2xl absolute z-0 inset-0 overflow-hidden">
              <UiImg :src="item.logo" class="w-full h-full object-cover" />
            </div>
            <div class="absolute flex top-2 right-2 md:right-4 z-10">
              <LinkCell
                defaultStyle="flex"
                :daoInfo="{ twitter: item.twitter }"
              ></LinkCell>
              <LinkCell
                defaultStyle="flex"
                :daoInfo="{ website: item.link }"
              ></LinkCell>
            </div>
            <div
              style="backdrop-filter: blur(20px)"
              class="
                border border-white-010
                hover:border-white-040
                px-4
                py-6
                z-10
                flex flex-col
                items-center
                bg-black-80
                rounded-2xl
                h-full
              "
            >
              <UiImg
                :src="item.logo"
                class="mb-2 md:mb-4 w-12 md:w-20 h-12 md:h-20 rounded-full"
              />
              <div
                class="text-base text-center md:text-xl font-bold mb-1 md:mb-2"
              >
                {{ item.name }}
              </div>

              <div class="mb-1 md:mb-2 flex w-full justify-center gap-2">
                <div
                  class="
                    flex
                    items-center
                    gap-1
                    text-xs
                    rounded
                    py-1
                    px-2
                    bg-white-010
                    cursor-pointer
                  "
                  @click="redirectToDao(item.daoPath)"
                >
                  <UiImg
                    :src="item.organizationLogo"
                    class="w-5 h-5 rounded-full"
                  />
                  <div v-if="isDesktop">{{ item.organization }}</div>
                </div>
                <div
                  v-if="item.position"
                  class="
                    flex
                    items-center
                    text-xs
                    py-1
                    px-2
                    rounded
                    bg-secondary-7
                  "
                >
                  {{ item.position }}
                </div>
              </div>
              <tippy
                v-if="
                  (isDesktop && item?.introduction?.length > 112) ||
                  (!isDesktop && item?.introduction?.length > 37)
                "
                :content="item.introduction"
                :arrow="false"
              >
                <div
                  class="
                    line-clamp-2
                    md:line-clamp-3
                    text-center text-white-060 text-sm
                  "
                >
                  {{ item.introduction }}
                </div>
              </tippy>
              <div
                v-else
                class="
                  line-clamp-2
                  md:line-clamp-3
                  text-center text-white-060 text-sm
                "
              >
                {{ item.introduction }}
              </div>
            </div>
          </div>
          <div v-else class="flex justify-between py-3 rounded-2xl">
            <div class="flex items-center px-4 gap-2" style="width: 240px">
              <UiImg
                :src="item.logo"
                class="cursor-pointer w-12 h-12 rounded-full"
              />
              <div class="text-base font-bold">{{ item.name }}</div>
            </div>
            <div class="flex items-center px-4" style="width: 123px">
              <UiImg
                @click="redirectToDao(item.daoPath)"
                :src="item.organizationLogo"
                class="w-8 h-8 rounded-full"
              />
            </div>
            <div
              class="flex items-center px-4 font-bold text-base"
              style="width: 144px"
            >
              {{ item.position }}
            </div>

            <div
              class="flex items-center px-4 text-xs font-bold"
              style="width: 263px"
            >
              <tippy
                v-if="item?.introduction?.length > 112"
                :content="item.introduction"
                :arrow="false"
              >
                <div class="line-clamp-2">
                  {{ item.introduction }}
                </div>
              </tippy>
              <div v-else class="line-clamp-2">
                {{ item.introduction }}
              </div>
            </div>
            <div
              class="flex items-center justify-end px-4"
              style="width: 124px"
            >
              <LinkCell
                defaultStyle="flex"
                :daoInfo="{ twitter: item.twitter }"
              ></LinkCell>
              <LinkCell
                defaultStyle="flex"
                :daoInfo="{ website: item.link }"
              ></LinkCell>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="loading"
        class="
          grid grid-cols-2
          md:grid-cols-3
          w-full
          gap-x-2
          md:gap-x-6
          gap-y-2
          md:gap-y-4
        "
      >
        <Skeletor
          v-for="(item, i) in [1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :key="i"
          style="height: 282px"
          class="w-full rounded-lg"
        ></Skeletor>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useDesktop, useReqByBool } from '@/hooks';
import { getTopDaosByTopPerson } from '@/api/annualRanking.ts';
import { onMounted, computed, reactive, ref } from 'vue';
import UiImg from '@/components/UiImg.vue';
import CountUp from '@/components/CountUp.vue';
import { Skeletor } from 'vue-skeletor';
import LinkCell from '@/components/LinkCell.vue';
const isDesktop = useDesktop('md');
const redirectToDao = (daoPath) => {
  window.open(`/dao/${daoPath}`);
};
const container = ref(null);

const state = reactive({
  itemsList: [],
  displayedItems: 20,
  viewStateList: false,
});
const displayedItemsArray = computed(() => {
  // return state.itemsList.slice(0, state.displayedItems);
  return state.itemsList;
});
const checkScroll = () => {
  const containerElement = container.value;

  if (
    Math.ceil(containerElement.scrollTop) + containerElement.clientHeight >=
    containerElement.scrollHeight
  ) {
    state.displayedItems += 10;
  }
};
const { loadData, loading } = useReqByBool(async () => {
  const res = await getTopDaosByTopPerson();
  console.log('daoby top person', res);
  state.itemsList = res;
});

onMounted(() => {
  loadData();
});
</script>
<style>
.data-container {
  /* max-height: 780px; */
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
